"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Icon = void 0;

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _AprendaComProjetos = _interopRequireDefault(require("./images/icons/AprendaComProjetos"));

var _Arrow = _interopRequireDefault(require("./images/icons/Arrow"));

var _Calendar = _interopRequireDefault(require("./images/icons/Calendar"));

var _Carreira = _interopRequireDefault(require("./images/icons/Carreira"));

var _Empregabilidade = _interopRequireDefault(require("./images/icons/Empregabilidade"));

var _FacebookIcon = _interopRequireDefault(require("./images/icons/FacebookIcon"));

var _EmptyUser = _interopRequireDefault(require("./images/icons/EmptyUser"));

var _FocoNaCarreira = _interopRequireDefault(require("./images/icons/FocoNaCarreira"));

var _FullStar = _interopRequireDefault(require("./images/icons/FullStar"));

var _InstagramIcon = _interopRequireDefault(require("./images/icons/InstagramIcon"));

var _LinkedinIcon = _interopRequireDefault(require("./images/icons/LinkedinIcon"));

var _MapMarker = _interopRequireDefault(require("./images/icons/MapMarker"));

var _Mentoria = _interopRequireDefault(require("./images/icons/Mentoria"));

var _MentoriasMensais = _interopRequireDefault(require("./images/icons/MentoriasMensais"));

var _Play = _interopRequireDefault(require("./images/icons/Play"));

var _TwitterIcon = _interopRequireDefault(require("./images/icons/TwitterIcon"));

var _YoutubeIcon = _interopRequireDefault(require("./images/icons/YoutubeIcon"));

var _FlippedClassroom = _interopRequireDefault(require("./images/icons/FlippedClassroom"));

var _Food = _interopRequireDefault(require("./images/icons/Food"));

var _Keyboard = _interopRequireDefault(require("./images/icons/Keyboard"));

var _Books = _interopRequireDefault(require("./images/icons/Books"));

var _Growing = _interopRequireDefault(require("./images/icons/Growing"));

var _Watch = _interopRequireDefault(require("./images/icons/Watch"));

var _SchoolBus = _interopRequireDefault(require("./images/icons/SchoolBus"));

var _Garlands = _interopRequireDefault(require("./images/icons/Garlands"));

var _Arrows = _interopRequireDefault(require("./images/icons/Arrows"));

var _Teamwork = _interopRequireDefault(require("./images/icons/Teamwork"));

var _Console = _interopRequireDefault(require("./images/icons/Console"));

var _Heart = _interopRequireDefault(require("./images/icons/Heart"));

var _Wrench = _interopRequireDefault(require("./images/icons/Wrench"));

var _Speedometer = _interopRequireDefault(require("./images/icons/Speedometer"));

var _Minus = _interopRequireDefault(require("./images/icons/Minus"));

var _Plus = _interopRequireDefault(require("./images/icons/Plus"));

var _Spinner = _interopRequireDefault(require("./images/icons/Spinner"));

var _Online = _interopRequireDefault(require("./images/icons/Online"));

var _Connectividade = _interopRequireDefault(require("./images/icons/Connectividade"));

var _FastLearning = _interopRequireDefault(require("./images/icons/FastLearning"));

var _Hacker = _interopRequireDefault(require("./images/icons/stacks/Hacker"));

var _Hipster = _interopRequireDefault(require("./images/icons/stacks/Hipster"));

var _Hustler = _interopRequireDefault(require("./images/icons/stacks/Hustler"));

var _Hyper = _interopRequireDefault(require("./images/icons/stacks/Hyper"));

var _Human = _interopRequireDefault(require("./images/icons/stacks/Human"));

var _Brainstorm = _interopRequireDefault(require("./images/icons/business/Brainstorm"));

var _Business = _interopRequireDefault(require("./images/icons/business/Business"));

var _Growth = _interopRequireDefault(require("./images/icons/business/Growth"));

var _GraphicDesign = _interopRequireDefault(require("./images/icons/design-development/GraphicDesign"));

var _LightBulb = _interopRequireDefault(require("./images/icons/design-development/LightBulb"));

var _Settings = _interopRequireDefault(require("./images/icons/design-development/Settings"));

var _Bulb = _interopRequireDefault(require("./images/icons/education-and-research/Bulb"));

var _Heads = _interopRequireDefault(require("./images/icons/interaction/Heads"));

var _Mountains = _interopRequireDefault(require("./images/icons/sport-activities/Mountains"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin: 0 auto;\n    max-width: ", ";\n    max-height: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin: 0 auto;\n    text-align: center;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var iconLogoMap = {
  AprendaComProjetos: _AprendaComProjetos.default,
  Arrow: _Arrow.default,
  Arrows: _Arrows.default,
  Books: _Books.default,
  Bulb: _Bulb.default,
  Brainstorm: _Brainstorm.default,
  Business: _Business.default,
  Calendar: _Calendar.default,
  Carreira: _Carreira.default,
  Console: _Console.default,
  Empregabilidade: _Empregabilidade.default,
  FacebookIcon: _FacebookIcon.default,
  EmptyUser: _EmptyUser.default,
  FocoNaCarreira: _FocoNaCarreira.default,
  FlippedClassroom: _FlippedClassroom.default,
  Food: _Food.default,
  FullStar: _FullStar.default,
  Garlands: _Garlands.default,
  GraphicDesign: _GraphicDesign.default,
  Growth: _Growth.default,
  Growing: _Growing.default,
  Hacker: _Hacker.default,
  Heads: _Heads.default,
  Heart: _Heart.default,
  Hipster: _Hipster.default,
  Hustler: _Hustler.default,
  Hyper: _Hyper.default,
  Human: _Human.default,
  InstagramIcon: _InstagramIcon.default,
  Keyboard: _Keyboard.default,
  LightBulb: _LightBulb.default,
  LinkedinIcon: _LinkedinIcon.default,
  MapMarker: _MapMarker.default,
  Mentoria: _Mentoria.default,
  MentoriasMensais: _MentoriasMensais.default,
  Minus: _Minus.default,
  Mountains: _Mountains.default,
  Play: _Play.default,
  Plus: _Plus.default,
  SchoolBus: _SchoolBus.default,
  Settings: _Settings.default,
  Speedometer: _Speedometer.default,
  Teamwork: _Teamwork.default,
  TwitterIcon: _TwitterIcon.default,
  Spinner: _Spinner.default,
  Watch: _Watch.default,
  Wrench: _Wrench.default,
  YoutubeIcon: _YoutubeIcon.default,
  Online: _Online.default,
  Connectividade: _Connectividade.default,
  FastLearning: _FastLearning.default
};

var getType = function getType(type) {
  return iconLogoMap[type];
};

var iconColorProfiles = {
  primary: {
    offset: "#63DC3E",
    border: "#242523"
  },
  secondary: {
    offset: "#E0D2EF",
    border: "#242523"
  },
  disable: {
    offset: "#F0F0F0",
    border: "#CCCCCC"
  }
};

var getColorProfile = function getColorProfile(type) {
  return iconColorProfiles[type];
};

var Icon = function Icon(_ref) {
  var type = _ref.type,
      size = _ref.size,
      colorProfile = _ref.colorProfile,
      props = _objectWithoutProperties(_ref, ["type", "size", "colorProfile"]);

  var Component = getType(type);
  var color = getColorProfile(colorProfile);

  var Wrapper = _styledComponents.default.span(_templateObject());

  var Svg = _styledComponents.default.svg(_templateObject2(), function (_ref2) {
    var size = _ref2.size;
    return "".concat(size, "px");
  }, function (_ref3) {
    var size = _ref3.size;
    return "".concat(size, "px");
  });

  return _react.default.createElement(Wrapper, null, _react.default.createElement(Svg, _extends({
    size: size
  }, props), _react.default.createElement(Component, {
    borderColor: color.border,
    offsetColor: color.offset
  })));
};

exports.Icon = Icon;
Icon.propTypes = {
  size: _propTypes.default.string.isRequired,
  type: _propTypes.default.string.isRequired,
  colorProfile: _propTypes.default.oneOf(["primary", "secondary", "disable"])
};
Icon.defaultProps = {
  colorProfile: "primary"
};
var _default = Icon;
exports.default = _default;